import MembershipRolesDisplay from '@/components/membership/membership-roles-display';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/originui/table';
import { useSwitchAuthContextMutation } from '@/hooks/auth/mutations/use-switch-auth-context.mutation';

import { MembershipGroup } from '@/types/membership-group/membership-group';

interface GroupsTableProps {
  membershipGroups: MembershipGroup[];
}

export default function GroupsTable({ membershipGroups }: GroupsTableProps) {
  const mutation = useSwitchAuthContextMutation();

  return (
    <div>
      <Table>
        <TableHeader>
          <TableRow className="hover:bg-transparent">
            <TableHead>Grupp</TableHead>
            <TableHead>Roll</TableHead>
            {/*   <TableHead className="text-right">Hantera</TableHead> */}
          </TableRow>
        </TableHeader>
        <TableBody>
          {membershipGroups.map((item) => (
            <TableRow key={item.groupId} onClick={() => mutation.mutate(item.groupId)} className="cursor-pointer">
              <TableCell className="font-medium whitespace-nowrap ">{item.name}</TableCell>
              <TableCell>
                <MembershipRolesDisplay roles={item.membershipRoles} />
              </TableCell>

              {/* <TableCell className="text-center">
                <GroupDropdown />
              </TableCell> */}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
